import { createFileRoute } from "@tanstack/react-router";

import { AdminCard, ListState } from "@/components/admin/primitives";
import { formatDate } from "@/lib/dates";
import { formatBRL } from "@/lib/format";
import { useResellerCustomers } from "@/lib/resellers";

export const Route = createFileRoute("/revendedor/_area/clientes")({
  head: () => ({ meta: [{ title: "Meus clientes — Revenda MonteBox" }] }),
  component: ResellerCustomers,
});

/**
 * A carteira: quem comprou pela primeira vez pelo link (ou foi vinculado
 * pela administração).
 *
 * O telefone vem mascarado — o bastante para reconhecer o cliente, sem
 * entregar o contato de quem, no fim, é cliente da empresa.
 */
function ResellerCustomers() {
  const customers = useResellerCustomers();
  const rows = customers.data ?? [];

  return (
    <div className="flex flex-col gap-4">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight text-mb-navy">
          Meus clientes
        </h1>
        <p className="mt-1 text-sm text-mb-muted">
          Clientes que fizeram a primeira compra pelo seu link. Toda compra deles conta para você,
          com ou sem link.
        </p>
      </div>

      <AdminCard className="overflow-hidden">
        <ListState
          loading={customers.isLoading}
          error={customers.error}
          empty={rows.length === 0}
          emptyLabel="Nenhum cliente ainda. O cliente entra aqui quando a primeira compra dele pelo seu link é paga."
        />
        {rows.length > 0 && (
          <div className="overflow-x-auto">
            <table className="w-full min-w-[640px] text-sm">
              <thead className="bg-mb-surface text-left text-[11px] font-bold uppercase tracking-[0.08em] text-mb-muted">
                <tr>
                  <th className="px-6 py-3">Cliente</th>
                  <th className="px-3 py-3">Desde</th>
                  <th className="px-3 py-3 text-right">Compras</th>
                  <th className="px-3 py-3 text-right">Total comprado</th>
                  <th className="px-6 py-3 text-right">Última compra</th>
                </tr>
              </thead>
              <tbody className="tabular-nums">
                {rows.map((customer) => (
                  <tr key={customer.id} className="border-t border-mb-line">
                    <td className="px-6 py-3">
                      <p className="font-semibold text-mb-ink">{customer.name}</p>
                      <p className="text-xs text-mb-muted">{customer.phone}</p>
                    </td>
                    <td className="px-3 py-3 text-mb-muted">{formatDate(customer.linkedAt)}</td>
                    <td className="px-3 py-3 text-right text-mb-muted">{customer.sales}</td>
                    <td className="px-3 py-3 text-right text-mb-ink">
                      {formatBRL(customer.revenue)}
                    </td>
                    <td className="px-6 py-3 text-right text-mb-muted">
                      {customer.lastSaleAt ? formatDate(customer.lastSaleAt) : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </AdminCard>
    </div>
  );
}
